const scrollContainer = document.getElementById("scrollable-titles");
const clonedTitles = [];
const legacyTitle = document.querySelector(".hero--title");

if (legacyTitle) {
  const legacyTitleClone = document.createElement("h2");
  legacyTitleClone.textContent = legacyTitle.textContent;
  legacyTitleClone.className = "active";
  legacyTitleClone.id = "legacy-clone";
  scrollContainer.appendChild(legacyTitleClone);
  clonedTitles.push(legacyTitleClone);
}

var titles = Array.from(
  document.querySelectorAll(".legacy-collage .titles h2")
).filter(function (title) {
  return title.textContent.trim() !== "";
});

titles.forEach((title, index) => {
  const titleClone = title.cloneNode(true);
  scrollContainer.appendChild(titleClone);
  clonedTitles.push(titleClone);

  titleClone.addEventListener("click", () => {
    const parentCollage = title.closest(".legacy-collage");
    const elementPosition =
      parentCollage.getBoundingClientRect().top + window.scrollY;

    window.scrollTo({
      top: elementPosition,
      behavior: "smooth",
    });
  });
});

document.getElementById("legacy-clone").addEventListener("click", function () {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
});

const legacyCollages = document.querySelectorAll('.legacy-collage');
legacyCollages.forEach((collage, index) => {
  collage.setAttribute('data-block', index + 5);
});

function isInViewport(element) {
  const elementTop = element.getBoundingClientRect().top;
  const elementBottom = element.getBoundingClientRect().bottom;
  const viewportMiddle = window.innerHeight / 10;
  return elementBottom > viewportMiddle && elementTop < viewportMiddle;
}

function scrollFadeIn(element, offset, start) {
  scrollFade(element, offset, start, false);
}

function scrollFadeOut(element, offset, start) {
  scrollFade(element, offset, start, true);
}

function scrollFade(element, offset, start, fadeOut) {
  const obj = element;
  let position = obj.getBoundingClientRect().top + window.scrollY;
  let myOffset = offset || 0;
  start = start || 0;
  fadeOut = fadeOut || false;

  const onScroll = () => {
    const scrollPos = window.scrollY - start;
    const positionRelative =
      document.querySelector("[data-block].in-view")?.getBoundingClientRect()
        .top + window.scrollY;
    const opacityValOg = fadeOut ? 1 : 1 - positionRelative / 100;
    const opacityVal = Math.min(opacityValOg, 1);

    obj.style.opacity = opacityVal;
  };

  const onResize = () => {
    position = obj.getBoundingClientRect().top + window.scrollY;
    myOffset = offset - window.innerHeight + position;
  };

  window.addEventListener("scroll", onScroll);
  window.addEventListener("resize", onResize);

  onScroll();
}

let activeSlideIndex = -1;

window.addEventListener("scroll", function () {
  const slides = document.querySelectorAll("[data-block]");
  const firstSlide = slides[0];
  const lastSlide = slides[slides.length - 1];
  const legacyClone = document.getElementById("legacy-clone");
  const isAboveFirstSlide =
    window.scrollY < firstSlide.getBoundingClientRect().top + window.scrollY;
  const isBelowLastSlide =
    window.scrollY > lastSlide.getBoundingClientRect().bottom + window.scrollY;

  if (isAboveFirstSlide) {
    clonedTitles.forEach((title) => title.classList.remove("active"));
    legacyClone.classList.add("active");
    scrollContainer.scrollTo({
      left: 0,
      behavior: "smooth",
    });
    activeSlideIndex = -1;
  } else {
    legacyClone.classList.remove("active");
  }

  if (isAboveFirstSlide || isBelowLastSlide) {
    slides.forEach((slide) => {
      slide.classList.remove("in-view");
      const slideTitle = slide.querySelector(".titles h2");
      slideTitle.classList.remove("fixed");
    });
    activeSlideIndex = -1;
  }

  let anyTitleActive = false;

  slides.forEach((slide, index) => {
    const slideTitle = slide.querySelector(".titles h2");
    const isCurrentInView = isInViewport(slide);

    if (slideTitle.textContent.trim() !== "") {
      if (isCurrentInView) {
        if (activeSlideIndex !== index) {
          activeSlideIndex = index;
          slide.classList.add("in-view");
          slideTitle.classList.add("fixed");
          clonedTitles.forEach((title) => {
            if (slideTitle.textContent.trim() == title.textContent.trim()) {
              title.classList.add("active");
              anyTitleActive = true;

              const clonedRect = title.getBoundingClientRect();
              const scrollPosition =
                clonedRect.left -
                scrollContainer.getBoundingClientRect().left +
                scrollContainer.scrollLeft;

              scrollContainer.scrollTo({
                left: scrollPosition,
                behavior: "smooth",
              });
            }
          });
        }
      } else {
        if (activeSlideIndex !== index) {
          slide.classList.remove("in-view");
          slideTitle.classList.remove("fixed");
          clonedTitles.forEach((title) => {
            if (slideTitle.textContent.trim() == title.textContent.trim()) {
              title.classList.remove("active");
            }
          });
        }
      }
    }
  });

  if (anyTitleActive) {
    legacyClone.classList.remove("active");
  }
});
